<template>
  <div class="line-chart">
    <e-charts ref="chart" :options="chartOption" :init-options="initOptions" style="width: 100%" />
  </div>
</template>

<script>
import ECharts from 'vue-echarts';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/chart/line';
import useAppConfig from '@core/app-config/useAppConfig';
import { computed } from '@vue/composition-api';

export default {
  name: 'LineChartComponent',
  components: {
    ECharts
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    categories: {
      type: Array,
      default: () => []
    },
    series: {
      type: Array,
      default: () => []
    },
    smooth: {
      type: Boolean,
      default: true
    },
    area: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Array,
      default: () => ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#00CFE8']
    }
  },
  setup() {
    const { skin } = useAppConfig();
    const isDark = computed(() => skin.value === 'dark');

    return { isDark };
  },
  data() {
    return {
      initOptions: {
        renderer: 'svg',
        width: 'auto',
        height: 'auto'
      }
    };
  },
  computed: {
    chartOption() {
      return {
        color: this.colors,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          textStyle: {
            fontSize: 12,
            color: this.isDark ? '#d0d2d6' : '#333'
          },
          backgroundColor: this.isDark ? 'rgba(40, 48, 70, 0.9)' : 'rgba(255, 255, 255, 0.9)',
          borderColor: this.isDark ? '#3b4253' : '#eee',
          borderWidth: 1
        },
        grid: {
          left: 20,
          right: 25,
          bottom: 10,
          top: this.series.length > 1 ? 40 : 20,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: ['4%', '4%'],
          data: this.categories,
          axisLine: {
            lineStyle: {
              color: this.isDark ? '#3b4253' : 'rgb(110, 107, 123)'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            fontSize: 11,
            rotate: 30,
            interval: 0,
            margin: 12,
            color: this.isDark ? '#b4b7bd' : '#6e6b7b'
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: this.isDark ? '#3b4253' : '#eee',
              type: 'dashed'
            }
          },
          axisLabel: {
            fontSize: 11,
            color: this.isDark ? '#b4b7bd' : '#6e6b7b'
          }
        },
        series: this.series.map(item => ({
          name: item.name,
          type: 'line',
          stack: this.area ? 'Total' : undefined,
          smooth: this.smooth,
          symbolSize: 6,
          areaStyle: this.area
            ? {
                opacity: 0.8
              }
            : null,
          emphasis: {
            focus: 'series'
          },
          data: item.data
        }))
      };
    }
  }
};
</script>

<style scoped>
.line-chart {
  width: 100%;
  height: 100%;
  min-height: 250px;
}
</style>
